import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface GetArticleHeaderDrainageByAppResponse {
  article_header_copy: string;
  article_drainage_image: string;
};

export class GetArticleHeaderDrainageByAppData {
  // @Required("Article header copy cannot be empty")
  @IsString("Article header copy must be a string")
  articleHeaderCopy: string;

  // @Required("Article drainage image cannot be empty")
  @IsString("Article drainage image must be a string")
  articleDrainageImage: string;
}

const transformAndValidateAgent = (
  response: GetArticleHeaderDrainageByAppResponse
): GetArticleHeaderDrainageByAppData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, GetArticleHeaderDrainageByAppData);
  } catch (error) {
    console.error("GetArticleHeaderDrainageByApp data validation failed:", error.message);
    throw error;
  }
};

/** 获取 Agent 文章设置（页眉,底图） */
export const getArticleHeaderDrainageByApp = async (agentId: string): Promise<GetArticleHeaderDrainageByAppData> => {
  const response = await api.post<GetArticleHeaderDrainageByAppResponse>('/push_info_user_subscription_setting/get-article-header-drainage-by-app', {
    agent_id: agentId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
